// removed by extract-text-webpack-plugin
module.exports = {"category":"CategoryPage__category___2Xovv"};


//////////////////
// WEBPACK FOOTER
// ./assets/js/css/CategoryPage.less
// module id = 69
// module chunks = 0 1